const config = {
  apiBaseUrl: '/donutem/:stage:/DONUT-EM-API_BASE_URL',
  rcApiBaseUrl: '/donutem/:stage:/DONUT-EM-RC_API_BASE_URL',
  rcApiInternalUrl: '/donutem/:stage:/DONUT-EM-RC_API_INTERNAL_URL',
  rc_client_Id: '/donutem/:stage:/DONUT-EM-CLIENT_ID',
  rc_authorize_uri: '/donutem/:stage:/DONUT-EM-RC_AUTHORIZE_URI',
  rc_jwks_url: '/donutem/:stage:/DONUT-EM-JWKS_URL',
  jwksAppName: {
    production: '/donutem/:stage:/DONUT-EM-JWKS_APP_NAME',
    sandBox: '/donutem/:stage:/DONUT-EM-JWKS_SANDBOX_APPNAME',
  },
};

module.exports = config;